import {
  Button,
  Input,
  Form,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import type { LicenseFilters } from "../../api/licenses/licenses.types";
import { Filter } from "lucide-react";

interface LicensesFilterProps {
  onFilter: (data: Partial<LicenseFilters>) => void;
  onClear: () => void;
  initialFilters?: Partial<LicenseFilters>;
}

export const LicensesFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: LicensesFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<LicenseFilters>({
    defaultValues: {
      structureName: initialFilters?.structureName ?? "",
      complexName: initialFilters?.complexName ?? "",
      moduleName: initialFilters?.moduleName ?? "",
    },
  });

  const handleFilter = (data: LicenseFilters) => {
    onFilter(data);
  };

  const handleClear = () => {
    form.reset();
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("management.licenses.form.label.structure")}:`}
            name="structureName"
            type="text"
            placeholder={translate(
              "management.licenses.form.placeholder.filterStructure",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.licenses.form.label.complex")}:`}
            name="complexName"
            type="text"
            placeholder={translate(
              "management.licenses.form.placeholder.filterComplex",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.licenses.form.label.module")}:`}
            name="moduleName"
            type="text"
            placeholder={translate(
              "management.licenses.form.placeholder.filterModule",
            )}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("management.licenses.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("management.licenses.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
